import BaseCard from "../../../components/ui/BaseCard";
import BaseFeedback from "../../../components/ui/BaseFeedback";

const FeedbackTab = ({ workOrderDetail }) => {
  return (
    <BaseCard className="pt-4 pb-72 px-16 rounded-lg" elevation={1}>
      <div className="border-bottom mb-4 flex items-center pb-1">
        <h6 className="text-dark">Feedback</h6>
      </div>
      <BaseFeedback
        feedbackReceived={workOrderDetail?.feedback?.feedbackReceived}
        feedbackGiven={workOrderDetail?.feedback?.feedbackGiven}
      />
    </BaseCard>
  );
};

export default FeedbackTab;
